/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { ToastContainer, Zoom } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import queryClient from "./config/queryClient";
import AppRouter from "./router/Router";
import { I18nextProvider } from "react-i18next";
import i18n from "./locales/i18n";
import { ThemeProvider } from "context/ThemeContext";
import Splash from "modules/Splash/Splash";
import ErrorBoundary from "modules/errors/ErrorBoundary";
import { initializeCsrfToken } from "services/csrfService";

const AppContent: React.FC = () => {
	const [showSplash, setShowSplash] = useState(true);

	useEffect(() => {
		(async () => {
			await initializeCsrfToken();
			console.log("CSRF token initialized");
		})();
	}, []);

	useEffect(() => {
		const splashShown = sessionStorage.getItem("splashShown");
		if (splashShown) {
			setShowSplash(false);
		} else {
			const timer = setTimeout(() => {
				setShowSplash(false);
				sessionStorage.setItem("splashShown", "true");
			}, 3000);

			return () => clearTimeout(timer);
		}

		return undefined;
	}, []);

	if (showSplash) {
		return <Splash />;
	}

	return (
		<>
			<ToastContainer
				position="top-right"
				autoClose={3000}
				limit={3}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
				transition={Zoom}
			/>
			<AppRouter />

			{process.env.NODE_ENV === "development" && (
				<ReactQueryDevtools initialIsOpen={false} position="bottom" />
			)}
		</>
	);
};

const App: React.FC = () => (
	<I18nextProvider i18n={i18n}>
		<ErrorBoundary>
			<ThemeProvider>
				<QueryClientProvider client={queryClient}>
					<AppContent />
				</QueryClientProvider>
			</ThemeProvider>
		</ErrorBoundary>
	</I18nextProvider>
);

export default App;
